import styled from 'styled-components';

interface ContainerProps {
    $designviewmode: boolean;
    $hidepassivhauscolor: boolean;
}

interface SquareProps {
    $designviewmode: boolean;
    color: string;
}

export const Container = styled.div<ContainerProps>`
    display: flex;
    flex-direction: column;
    margin-top: ${(props) =>
        props.$designviewmode
            ? props.$hidepassivhauscolor
                ? '1.25em'
                : '0.625em'
            : '3rem'};
`;

export const SquareTextHolder = styled.div`
    display: flex;
    align-items: center;
`;

export const Square = styled.div<SquareProps>`
    width: 1.125em;
    height: 1.125em;
    margin-right: ${(props) => (props.$designviewmode ? '0.625em' : '1.25em')};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.color};
`;

export const Text = styled.span`
    font-size: 0.875rem;
    display: flex;
    align-items: center;
`;

export const StripedSquare = styled(Square)`
    margin-right: ${(props) => (props.$designviewmode ? '0.625em' : '1.25em')};
    background: repeating-linear-gradient(
        135deg,
        ${(props) => props.color},
        ${(props) => props.color} 0.1875em,
        white 0.1875em,
        white 0.375em
    );
`;
